import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { TestId } from '@repo/test-id';
import { tr } from '@repo/locale';
import { toast } from '@repo/toast';

import { useParkingSearchStore } from '@shared/stores/useParkingSearchStore';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

export default function ParkingChosenGuard() {
  const navigate = useNavigate();
  const parkingSlug = useParkingSearchStore((state) => state.selectedParking.slug);
  const testId = TestId.root('parkingChosenGuardError');

  useEffect(() => {
    if (!parkingSlug) {
      toast.danger(tr('reservations:expired_error_message'), testId);
      navigate(ROUTE_PATHS[RouteName.MAP], { replace: true });
    }
  }, [parkingSlug, testId, navigate]);

  if (!parkingSlug) {
    return null;
  }

  return <Outlet />;
}
